/*
 * Copyright (c) Nexign, JSC, 2023.
 */
/**
 *
 *
 * @author Evgeniy Naumov
 * @version 1.25.1
 * @since 1.25.1
 */

import { ITableInitialise } from '@/main/modules/table/types';

export const NEWS_TABLE_CONFIG: ITableInitialise = {
    meta: {
        url: 'news/manage/meta',
    },
    list: {
        url: 'news/manage/list',
    },
    filterAndSort: {
        url: 'news/manage/filter-and-sort',
        suggest: 'news/suggest',
    },
};

export enum ENewsTableFileds {
    ID = 'id',
    TYPE = 'type',
    TITLE = 'title',
    PUBLISH_FROM = 'publishFrom',
    PUBLISH_TO = 'publishTo',
    FOR_ALL = 'forAll',
    CREATED = 'created',
    AUTHOR = 'author',
    DELETE = 'delete',
}
